import React from "react";
import PropTypes from 'prop-types';

import { Button } from "reactstrap";

import PlaceholderAlert from "shared/react_components/PlaceholderAlert";
import PlaceholderBody from "integrations/components/PlaceholderBody";

const ErrorPlaceholder = ({ message, onRetry }) => (
  <PlaceholderAlert icon="error_outline" color="danger">
    <PlaceholderBody>
      <p>{message}</p>
      <Button color="link" onClick={onRetry}>Retry</Button>
    </PlaceholderBody>
  </PlaceholderAlert>
);

ErrorPlaceholder.propTypes = {
  message: PropTypes.string.isRequired,
  onRetry: PropTypes.func.isRequired
};

export default ErrorPlaceholder;
